import React, { useEffect, useState } from 'react';
import { initParticlesEngine } from '@tsparticles/react';
import { tsParticles } from '@tsparticles/engine';
import Particles from '@tsparticles/react';
import { Slide, Bounce, Roll } from 'react-awesome-reveal';
import { motion } from 'framer-motion';
import { Modal, Button, Form } from 'react-bootstrap';

import AZ from '../../assets/logos/logo2.png';
import C1 from '../../assets/images/MEMBERS-AZYEKOS_01-2.png';
import C2 from '../../assets/images/MEMBERS-AZYEKOS_02-2.png';
import C3 from '../../assets/images/MEMBERS-AZYEKOS_03-1.png';


const CardAdhesion = () => {
  const [engineInitialized, setEngineInitialized] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
const handleShow = () => setShowModal(true);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await tsParticles.loadOptions("tsparticles", {
        fullScreen: { enable: false },
        particles: {
          number: { value: 80 },
          size: { value: 4 },
          move: { enable: true, speed: 1 },
          opacity: { value: 0.6 },
          links: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.4,
            width: 1,
          },
        },
        interactivity: {
          events: {
            onHover: { enable: true, mode: "repulse" },
            resize: true,
          },
        },
        background: { color: "transparent" },
      });
    }).then(() => {
      setEngineInitialized(true);
    });
  }, []);

  return (
    <section
      id="main-container"
      className="main-container position-relative"
      style={{
        backgroundImage: 'url(images/assets/ban6.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Particules */}
      {engineInitialized && (
        <Particles id="tsparticles" className="position-absolute w-100 h-100" />
      )}

      <div className="container position-relative z-1 py-5">
      <div className="text-center mt-5">
          <motion.h1
            style={{fontFamily:'Times'}}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className='fw-bold text-white display-5'
          >
          CONTATCEZ NOUS !
          </motion.h1>
      
        
        </div>
        <div className="text-center mb-5">
          <Bounce>
            <motion.img
              src={AZ}
              alt="logo"
              className="img-fluid mb-3"
              style={{ maxWidth: 400 }}
              animate={{ rotate: [0, 10, -10, 0] }}
              transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
            />
          </Bounce>
         
        </div>

        <div className="row">
          <div className="col-lg-4">
            <Slide direction="left" triggerOnce={false}>
              <motion.img
                src={C1}
                alt="logo"
                className="img-fluid mb-3"
                style={{ maxWidth: 400 }}
                animate={{ y: [1, -30, 0] }}
                transition={{ repeat: Infinity, duration: 3 }}
              />
            </Slide>
           <p style={{fontFamily:'times', color:'#d8ba72'}} className='text-center fs-5'>  
            Siège Social
1368, Saint Christophe, Funa-Limete,
KINSHASA RD-CONGO

Représentation
Kolwezi, Lubumbashi, Likasi, Matadi,
Isiro, Kalemie, Goma, Bukavu,
Washington (USA)
             </p>
          </div>

          <div className="col-lg-4">
            <Roll triggerOnce={false}>
            <a href="callto:+243814213889"> {/* Remplace par ton numéro */}
              <motion.img
                src={C2}
                alt="logo"
                className="img-fluid mb-3"
                style={{ maxWidth: 400 }}
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ repeat: Infinity, duration: 4 }}
              />
               </a>
            </Roll>
            <p style={{fontFamily:'times', color:'#d8ba72'}} className='text-center fs-4'>   <i className="fa fa-phone"></i> +243 814 213 889 <br /> <br />  <i className="fa fa-phone"></i>  +243 971 746 522 </p>
          </div>

          <div className="col-lg-4">
            <Slide direction="right" triggerOnce={false}>
            <a href="mailto:infos@gekas-security.com"> {/* Remplace par ton adresse email */}
              <motion.img
                src={C3}
                alt="logo"
                className="img-fluid mb-3"
                style={{ maxWidth: 400 }}
                animate={{ rotate: [1, 20, -10, 1] }}
                transition={{ repeat: Infinity, duration: 6 }}
              />
               </a>
            </Slide>
            <p style={{fontFamily:'times', color:'#d8ba72'}} className='text-center fs-5'> 
            <a style={{fontFamily:'times', color:'#d8ba72'}} href="mailto:infos@gekas-security.com"> {/* Remplace par ton adresse email */}
                <i className="fa fa-envelope"></i> infos@gekas-security.com
                </a> <br />
               
                </p>
          </div>
        </div>

        {/* Texte animé et bouton CTA */}
   
      </div>


      
    </section>
  );
};

export default CardAdhesion;
